<div class="container container-max-width mt-4">
  <div class="not-found">
    <img class="mb-2" src="/quota/assets/404.png" alt="404" />
    <p>Resource not found</p>
  </div>
</div>
